var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Poster"},[_c('Header',{attrs:{"msg":"长按保存二维码"}}),_c('img',{class:_vm.isloading ? 'Poster-imgs':'Poster-img',style:(_vm.tabH),attrs:{"src":_vm.poster,"id":"pos"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"poster-bottom"},[_c('div',{staticClass:"tips"},[_vm._v("保存图片，分享给学生")])])
}]

export { render, staticRenderFns }